/* global dataLayer */

/**
* Common - Utils module
*/

import GlobalVars from './GlobalVars';
import AjaxURL from './AjaxURL';
import * as CheckoutStep from './CheckoutStepEnum';
// import {
//   retroCookie,
//   readCookie,
// } from './tools/Cookie';

const _ = {};
_.findKey = require('lodash/findKey');

require('core-js/es/promise');

window.dicoKeys = window.dicoKeys || {};

const cartBaseURL = 'checkout/cart.aspx';
const cartDirectoryName = 'checkout/';

/**
* Determines whether or not the given value is null, undefined or an empty string (optional).
*
* @param {Mixed} aValue            : The value to test.
* @param {Boolean} [abAllowBlank]  : Whether or not an empty string is not considered empty.
*
* @return {Boolean} Whether or not the value is null, undefined or an empty string.
*/
function isEmpty(aValue, abAllowBlank) {
  return (aValue === null) || (aValue === undefined) || (!abAllowBlank ? (aValue === '') : false);
}

/**
* Returns the given value or the default value if empty.
*
* @param {Mixed} aValue           : The value to test.
* @param {Mixed} aDefaultValue   : The defaut value.
* @param {Boolean} [abAllowBlank] : Whether or not an empty string is not considered empty.
*
* @return {Mixed} The given value or the default value if empty.
*/
function value(aValue, aDefaultValue, abAllowBlank) {
  return isEmpty(aValue, abAllowBlank) ? aDefaultValue : aValue;
}

function isAutonavi() {
  return (OCMS.GlobalVars.Brand === 'occ' && OCMS.GlobalVars.C === 90) || (OCMS.GlobalVars.Brand === 'mel' && OCMS.GlobalVars.C === 28);
}

/**
 * Returns the type of object that is passed in. If the object passed in is null or undefined it
 * returns false otherwise it returns one of the following values:<ul>
 * <li><b>string</b>: If the object passed is a string</li>
 * <li><b>number</b>: If the object passed is a number</li>
 * <li><b>boolean</b>: If the object passed is a boolean value</li>
 * <li><b>function</b>: If the object passed is a function reference</li>
 * <li><b>object</b>: If the object passed is an object</li>
 * <li><b>array</b>: If the object passed is an array</li>
 * <li><b>regexp</b>: If the object passed is a regular expression</li>
 * <li><b>element</b>: If the object passed is a DOM Element</li>
 * <li><b>nodelist</b>: If the object passed is a DOM NodeList</li>
 * <li><b>textnode</b>: If the object passed is a DOM text node
 * and contains something other than whitespace</li>
 * <li><b>whitespace</b>: If the object passed is a DOM text node and contains only whitespace</li>
 *
 * @param {Mixed} aoObject : the object.
 *
 * @return {String} : the type of object that is passed in.
 */
function type(aoObject) {
  if ((aoObject === undefined) || (aoObject === null)) {
    return false;
  }

  if (aoObject.htmlElement) {
    return 'element';
  }

  const objType = typeof aoObject;

  if ((objType === 'object') && aoObject.nodeName) {
    switch (aoObject.nodeType) {
      case 1: return 'element';
      case 3: return (/\S/).test(aoObject.nodeValue) ? 'textnode' : 'whitespace';
      default: break;
    }
  }

  if ((objType === 'object') || (objType === 'function')) {
    switch (aoObject.constructor) {
      case Array: return 'array';
      case RegExp: return 'regexp';
      default: break;
    }

    if ((typeof aoObject.length) === 'number') {
      if ((typeof aoObject.item) === 'function') {
        return 'nodelist';
      }
    }
  }

  return objType;
}

/**
*  animate scroll to target position
* @param  {jquerySelector|string} target target to scroll
* @param  {number} animDuration timer of the animation
* @param  {string} animType     easing of animation (linear/swing)
* @return target                [description]
*/

function scrollToContainer(target, animDuration = 500, animType = 'linear', waitEvent = false, marge = 0) {
  let $obj = $(target);
  let $header = $('#header');
  let headerIsSticky = $header.is('.o-header--sticky');

  const animateScroll = (newTar) => {
    if (newTar) {
      $obj = $(newTar);
    }
    let posTop = $obj.offset().top;
    $header = $('#header');
    headerIsSticky = $header.is('.o-header--sticky');

    if ($header.length && headerIsSticky) {
      posTop -= $header.height() + marge;
    }

    $('body, html').animate({
      scrollTop: posTop,
    }, {
      duration: animDuration,
      easing: animType,
    });
  };

  if (waitEvent) {
    $(window).on('scrollToContainer', (e, newTar) => {
      animateScroll(newTar);
    });
  } else {
    animateScroll();
  }

  return $obj;
}

function scrollTo(posTop, animDuration = 500, animType = 'linear') {
  const page = $('body, html');
  page.on('scroll mousedown keyup touchmove', () => {
    page.stop();
  })
    .animate(
    {
      scrollTop: posTop,
    },
    animDuration,
    animType,
    () => {
      page.off('scroll mousedown keyup touchmove');
    }
  );
}

function randomString(length) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  const stringLength = length;
  let randomstring = '';
  for (let i = 0; i < stringLength; i += 1) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}

/**
 * defined height of element targeted and save it in data-height
 * @param  {object|string} target
 * @return {string|array} the current or a list of element's height
 */
function defineCurrentHeight(target, options, callback) {
  let result = null;
  const $target = $(target);
  const param = {
    defaultHeight: null,
    cleanId: false,
    loadSaved: false,
  };

  Object.assign(param, options);

  function getH($obj) {
    if (!$obj.length) { return false; }

    const startH = parseInt($obj.css('height'), 10);
    const savedH = $obj.data('height');
    const childChange = $obj.data('childClass');
    if (((startH > 2 && childChange && $obj.children().hasClass(childChange))
      || param.loadSaved) && savedH) {
      return savedH;
    }
    const listChecked = $obj.find(':input:checked');
    const tarClone = $obj.clone(true);
    if (param.cleanId) {
      tarClone.find('[id]').removeAttr('id');
    }
    tarClone.css({
      opacity: 0,
      position: 'absolute',
      height: 'auto',
    });
    $obj.before(tarClone);
    const tarH = tarClone.height();
    tarClone.remove();
    listChecked.prop('checked', true);
    const endH = (startH !== tarH && startH > 2 && !param.defaultHeight) ? tarH : null;

    if (typeof param.defaultHeight === 'number') {
      $obj.css('height', param.defaultHeight);
    } else if (endH) {
      $obj.css('height', endH);
    } else if (startH > 2) {
      $obj.css('height', tarH);
    }

    if (!$obj.is(':empty') && $obj.children().attr('class')) {
      $obj.data('childClass', $obj.children().attr('class'));
    }
    if (tarH !== savedH) {
      $obj.attr('data-height', tarH).data('height', tarH);
    }
    return tarH;
  }

  if ($target.length > 1) {
    result = [];
    $target.each((i, el) => {
      result[i] = getH($(el));
    });
  } else {
    result = getH($target);
  }

  const Callback = () => {
    if (typeof callback === 'function' && callback()) {
      return callback($target, result);
    }
    return false;
  };

  Callback();

  return result;
}

function setAutomaticalHeight(element) {
  const $elem = $(element);
  $elem.height('auto');
  return $elem;
}

// Loader for buttons
class BtnLoading {
  constructor(btn, option = {}) {
    const opt = {
      animTimer: 500,
      txtAlt: 'txtalt',
      textCont: 'span',
      spinnerClass: 'a-spinner a-spinner--btn-loader',
      addClass: '',
    };
    this.option = Object.assign(opt, option);

    this.$target = $(btn);
    this.defaultText = '';
    this.altText = this.$target.data(this.option.txtAlt);
    this.waiting = false;
    this.animTimer = this.option.animTimer;
    this.textCont = this.$target.find(this.option.textCont) || this.$target;
    this.$target.addClass(this.option.spinnerClass);
  }

  wait() {
    if (!this.waiting) {
      this.waiting = true;
      this.defaultText = this.textCont.html();
      this.$target.addClass('js-activ');
      this.$target.attr('disabled', true);
      if (this.altText) {
        this.textCont.css('min-width', this.$target.width());
        this.hideText(this.altText);
      }
      if (this.option.addClass) {
        this.$target.addClass(this.option.addClass);
      }
    }
  }

  resume() {
    if (this.waiting) {
      this.waiting = false;
      setTimeout(() => {
        this.$target.removeClass('js-activ');
        this.$target.attr('disabled', false);
        if (this.altText) {
          this.hideText(this.defaultText).then(() => {
            this.textCont.css('min-width', '');
          });
        }
        if (this.option.addClass) {
          this.$target.removeClass(this.option.addClass);
        }
      }, this.animTimer);
    }
  }

  hideText(newText) {
    return new Promise((resolve) => {
      if (this.textCont.length) {
        this.textCont.addClass('js-hide');
        setTimeout(() => {
          this.textCont.html(newText);
        }, this.animTimer / 2);
        setTimeout(() => {
          this.textCont.removeClass('js-hide');
          resolve();
        }, this.animTimer);
      }
    });
  }

  toggle() {
    if (this.waiting) {
      this.resume();
    } else {
      this.wait();
    }
  }

  toggleOn(event) {
    this.$target.on(event, () => {
      this.toggle();
    });
  }
}

// Loader for area
class AreaLoading {
  constructor(area, option) {
    const opt = {
      msgClass: 'js-loading-message',
      wrapperClass: 'js-loading-wrapper',
      spinnerClass: 'a-spinner',
    };
    this.option = Object.assign(opt, option);

    this.$target = $(area);

    this.template = `
    <div class="${this.option.msgClass} m-area-loader" >
      <p class="a-text a-text--center a-text--section m-area-loader__txt" >${window.dicoKeys.Loading || 'Loading...'}</p>
      <div class="${this.option.spinnerClass} m-area-loader__spinner"></div>
    </div>`;
  }

  addLoadingMessage() {
    if (!this.$target.find(`.${this.option.msgClass}`).length) {
      // Create a wrapper to hide all content
      this.$target.find('> *').wrapAll(`<div class="${this.option.wrapperClass}" style="display:none" />`);
      // Add spinner and loading template
      this.$target.append(this.template);
    }
  }
  removeLoadingMessage() {
    // Remove spinner and loading template
    this.$target.find(`.${this.option.msgClass}`).remove();
    // Remove the wrapper
    this.$target.find(`.${this.option.wrapperClass} > *`).unwrap();
  }

  wait() {
    this.addLoadingMessage();
  }

  resume() {
    this.removeLoadingMessage();
  }
}

/**
 * Positionning container under header
 */
function offsetTop(container) {
  const $header = $('#header');
  const headerHeight = $header.outerHeight();

  if ($header.css('position') === 'fixed') {
    container.css('top', headerHeight);
  } else {
    container.css('top', '');
  }
}

/**
 * Returns URL with relative path
 * @param  {string} relativeUrl relative URL
 * @return {string}             URL
 */
function getUrl(relativeUrl) {
  const relUrl = /^\//.test(relativeUrl) ? relativeUrl : `/${relativeUrl}`;
  return `${window.top.location.protocol}//${window.top.location.host}${relUrl}`;
}

/**
 * Returns Home URL.
 * @return {string} Home URL with query strings c, l
 */
function getHomeUrl() {
  return `${window.top.location.protocol}//${window.top.location.host}/?c=${GlobalVars.C}&l=${GlobalVars.L}`;
}

/**
 * Get url parameters entry
 * @param  {string}  sParam param name
 * @param  {Boolean} isURL  Whether it is an URL, to returns correct URL. Defaults to false.
 * @return {String|Boolean}         Returns value
 */
function getUrlParameter(sParam, isURL = false) {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName = [];
  for (let i = 0; i < sURLVariables.length; i += 1) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      if (sParameterName[1] === undefined) {
        return true;
      }
      return isURL ? decodeURIComponent(sParameterName[1]) : sParameterName[1];
    }
  }

  return false;
}

function getUrlLabelParameter(sParam, isURL = false) {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName = [];
  for (let i = 0; i < sURLVariables.length; i += 1) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      if (sParameterName[0] === undefined) {
        return true;
      }
      return isURL ? decodeURIComponent(sParameterName[0]) : sParameterName[0];
    }
  }

  return false;
}

function getParameterFromURL(sParam, sQuery, isURL = false) {
  const sPageURL = decodeURIComponent(sParam.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName = [];
  for (let i = 0; i < sURLVariables.length; i += 1) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sQuery) {
      if (sParameterName[1] === undefined) {
        return true;
      }
      return isURL ? decodeURIComponent(sParameterName[1]) : sParameterName[1];
    }
  }

  return false;
}

function isSiteLightview() {
  // return getUrlParameter('lightview') === 'true' || (
  //   (GlobalVars.IsReskinV2 && retroCookie('lightview') === 'true') ||
  //   (!GlobalVars.IsReskinV2 && readCookie('lightview') === 'true')
  // ); // Buggy :'(
  return false;
}

function getDataFromURL(asURL) {
  let dataObject = {};

  if (!OCMS.utils.isEmpty(asURL)) {
    const regExp = /(.+?:)\/\/(.+?)(\/.+?)(?:(#.+)|(\?.+)|$)/;
    const matches = asURL.match(regExp);
    if (matches && matches.length > 1) {
      const keys = ['protocol', 'host', 'pathname', 'hash', 'search'];
      for (let i = 1; i < matches.length; i += 1) {
        let valueKey = matches[i];
        if ((valueKey === null) || (valueKey === undefined)) {
          valueKey = '';
        }

        const key = keys[i - 1];
        if (key) {
          dataObject[key] = valueKey;
        }
      }
    }
  }

  if ($.isEmptyObject(dataObject)) {
    dataObject = null;
  }

  return dataObject;
}

/**
 * Redirect to an URL
 */
function redirect(URL) {
  document.location.href = URL;
}

/**
 * Redirect to the cart page
 */
function goToCart() {
  redirect(`/${cartBaseURL}?c=${GlobalVars.C}&l=${GlobalVars.L}&gotobag=1`);
}

function goToOldCart() {
  redirect(`/ecombag.aspx?c=${GlobalVars.C}&l=${GlobalVars.L}&gotobag=1`);
}

/**
 * Ask for formated price
 * @param  {float} price
 * @param  {jQuery} $elem
 */
function getFormatedPrice(price, $elem) {
  $.ajax({
    type: 'GET',
    url: AjaxURL.formatprice,
    data: {
      task: 'formatprice',
      price,
      culture: GlobalVars.Currency,
    },
    complete(datas) {
      if ($elem.is('input[type=text], textarea, button')) {
        $elem.val(datas.responseText);
      } else {
        $elem.html(datas.responseText);
      }
    },
  });
}

/**
 * Returns whether or not we are on a spa site.
 * @return {Boolean} Whether or not we are on a spa site.
 */
function isOnSpaSite() {
  return ((GlobalVars.Brand === 'occ') && (GlobalVars.C === 92));
}

/**
 * Returns a timestamp from current date.
 * @return A timestamp.
 */
function getTimestamp() {
  const currentDate = new Date();

  return [
    currentDate.getFullYear(),
    (currentDate.getMonth() < 10) ? '0' : '',
    currentDate.getMonth() + 1,
    (currentDate.getDate() < 10) ? '0' : '',
    currentDate.getDate(),
  ].join('');
}

/**
 * Returns a 24hours format into 12hours format.
 * @param  {String} format 'hh:mm'.
 * @return hours with AM or PM.
 */
function formatInto12Hours(time) {
  const theTime = time.split(':');
  const hh = theTime[0];
  const mm = theTime[1];
  let dd = 'AM';
  let H = hh;

  if (H > 12) {
    H = hh - 12;
    dd = 'PM';
  } else if (H === '12') {
    dd = 'PM';
  } else if (H === '0' || H === '00') {
    H = 12;
  }

  let format = H;
  format += ':';
  format += mm;
  format += dd;

  return format;
}

/**
 * UTC timestamp in seconds from today
 * @return a timestamp since January 1st, 1970, 00:00
 */
function getUTCTimestamp() {
  return (new Date().getTime() / 1000) + (new Date().getTimezoneOffset() * 60);
}

/**
 * Returns a single number under 10 into 2 digits number.
 * @param  {Number}.
 * @return number format ex: '1' => '01'.
 */
function formatTwoDigits(number) {
  let num = number;

  if (num < 10) {
    num = `0${number}`;

    return num;
  }

  return num;
}

/**
 * Formats a URL for fallback images.
 * @param  {String} asUrl The image URL.
 * @return {String}       The formatted URL.
 */
function formatImageUrl(asUrl) {
  let querySymbol = '?';

  if (asUrl.indexOf(querySymbol) > -1) {
    querySymbol = '&';
  }

  return `${asUrl}${querySymbol}nodef=true`; // nodef=true returns no content. 404 only for fallback images
}

/**
 * getCheckoutStep
 * @return {integer} step number or null
 */
function getCheckoutStep() {
  return getUrlParameter('step') ? parseInt(getUrlParameter('step'), 10) : null;
}
/**
 * Indicates whether or not the current page is a "checkout" page.
 *
 * @return {Boolean} Whether or not the current page is a "checkout" page.
*/
function isCheckout() {
  const currentUrl = document.location.pathname.toLowerCase();
  return (currentUrl.indexOf(`/${cartBaseURL}`) > -1 || currentUrl.indexOf(`/${cartDirectoryName}`) > -1 || currentUrl.indexOf('ecombag') > -1);
}

function isPayment() {
  return document.location.pathname.toLowerCase().search(/payment.*\/.*?\.aspx/gi) > -1;
}

function isCheckoutCartPage() {
  const step = getCheckoutStep();
  const action = getUrlParameter('action');
  return isCheckout() && (
    step === CheckoutStep.STEP_1_CART ||
    (!step && !action)
  );
}

function isCheckoutLoginPage() {
  return isCheckout() && getCheckoutStep() === CheckoutStep.STEP_3_DELIVERY
    && $('[id$=_pnlLoginEmail]').length > 0;
}

function isCheckoutRegisterPage() {
  return isCheckout() && getCheckoutStep() === CheckoutStep.STEP_3_DELIVERY
    && $('[id$=_pnlStep3Create]').length > 0;
}

function isCheckoutRegisterGuestPage() {
  return isCheckout() && getCheckoutStep() === CheckoutStep.STEP_3_DELIVERY
    && $('[id$=_pnlStep3GuestCheckoutForm]').length > 0;
}

function isCheckoutDeliveryPage() {
  return isCheckout() && getCheckoutStep() === CheckoutStep.STEP_3_DELIVERY
    && $('[id$=_pnlStep3BillingShipping]').length > 0;
}

function isCheckoutPaymentPage() {
  return isCheckout() && getCheckoutStep() === CheckoutStep.STEP_4_PAYMENT;
}

function isOrderConfirmationPage() {
  return isCheckout()
    && $('[id$=_orderReviewWrapperArea]').length > 0;
}

/**
 * Returns if the given string is a valid email address.
 * @param  {String} mail.
 * @return {bool}.
 */
function isEmailValid(mail) {
  return /^\S[^!#$%&'*=?/^_`{|}~-]+@\S[^!#$%&'*+=?/^_`{|}~]+\.\S[^!#$%&'*+=?/^_`{|}~-]+$/.test(mail);
}

/**
 * Returns if the given string is a valid email address.
 * @param  {String} mail.
 * @return {bool}.
 */
function isEmailValidNewsletter(mail) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(mail);
}


/**
 * Returns a dataLayer push by data.
 * @param  {Object} data.
 * @return {Object} | null.
 */
function getDataLayerPush(data) {
  if (typeof dataLayer === 'undefined') {
    return null;
  }

  const key = _.findKey(dataLayer, data);

  if (typeof key === 'undefined') {
    return null;
  }

  return dataLayer[key];
}

function stripHTML(html) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

function isAlgoliaOn() {
  return typeof window.algolia !== 'undefined';
}

/**
 * Used to debouncing events (limit the triggering of an event), actually used in broadcast.js to limit the update refresh and catch websocket events all at once.
 *
 * @function debounce
 * @param {Function} callback - A callback function
 * @param {Number} time - A time value in millisecond
 */
function debounce(callback, time) {
  let interval;

  return (...args) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      interval = null;
      callback(...args);
    }, time);
  };
}

/**
 * Used to detect if an element is in viewport (possible use with visibility hidden)
 *
 * @function inViewport
 * @param {Object} elem - a Dom element
 * @return {Boolean}

 */
function inViewport(elem) {
  const isjQueryObj = (typeof jQuery !== 'undefined' && elem instanceof jQuery && elem.length === 1);
  let isIn = false;

  if ((typeof elem !== 'undefined' && elem !== null) || isjQueryObj) {
    let el;

    /* jQuery case */
    if (isjQueryObj) {
      el = elem.get(0);
    } else {
      el = elem;
    }

    if (el.nodeType === 1 && el.style.display !== 'none') {
      const html = document.documentElement;
      const r = el.getBoundingClientRect();

      isIn = (r
        && r.bottom >= 0
        && r.right >= 0
        && r.top <= html.clientHeight
        && r.left <= html.clientWidth
      );
    }
  }

  return isIn;
}

/**
 * Get rid of sticktly duplicated values in a given array
 *
 * @function removeDuplicates
 * @param {Array} Entry array
 * @return {Array} A new Array() where duplicate where strip

 */
function removeDuplicates(arr) {
  const out = [];

  for (let i = 0, iLen = arr.length; i < iLen; i += 1) {
    if (out.indexOf(arr[i]) === -1) {
      out.push(arr[i]);
    }
  }

  return out;
}

const isTargetChildOf = (target, parent) => parent.contains(target);

const isRTL = () => GlobalVars.SiteDirection === 'rtl';

const isHTTPS = () => location.protocol.indexOf('https') > -1;

const btnLoader = (param, options) => new BtnLoading(param, options);
const areaLoading = param => new AreaLoading(param);

window.btnLoader = btnLoader;
window.areaLoading = areaLoading;

/**
 * Calculates and displays the number of characters left.
 *
 * @param {Object|HTMLElement} txtArea - The textarea element.
 * @param {int} sizeMax - Max characters for git message
 * @param {charLeftElementId} charLeftElement ID - chars left element ID
*/
function checkTextareaLength(txtArea, sizeMax, charLeftElementId) {
  let $charLeftElement;
  const paramTxtArea = txtArea;
  const realLength = paramTxtArea.value.length;
  let length = txtArea.value.replace(/\r/ig, '').length;

  if (charLeftElementId !== null && charLeftElementId !== '') {
    $charLeftElement = $(`#${charLeftElementId}`);
  }

  if (length > sizeMax) {
    const tail = length - sizeMax;
    length = 500;
    paramTxtArea.value = paramTxtArea.value.substring(0, realLength - tail);
    if ($charLeftElement !== null) {
      $charLeftElement.text(0);
    }
  } else if ($charLeftElement !== null && $charLeftElement.length > 0) {
    $charLeftElement.text(sizeMax - length);
  }
}

/**
 *  Replace the last occurence of a given string in a string
 * @param {String} find
 * @param {String} replace
 * @param {String} string
 */
function replaceLast(find, replace, string) {
  const lastIndex = string.lastIndexOf(find);

  if (lastIndex === -1) {
    return string;
  }

  const beginString = string.substring(0, lastIndex);
  const endString = string.substring(lastIndex + find.length);

  return beginString + replace + endString;
}

// Named exports
export {
  isAutonavi,
  isEmpty,
  value,
  type,
  getCheckoutStep,
  isPayment,
  isCheckout,
  isCheckoutCartPage,
  isCheckoutLoginPage,
  isCheckoutRegisterPage,
  isCheckoutRegisterGuestPage,
  isCheckoutDeliveryPage,
  isCheckoutPaymentPage,
  isOrderConfirmationPage,
  scrollToContainer,
  scrollTo,
  defineCurrentHeight,
  btnLoader,
  areaLoading,
  getDataFromURL,
  isRTL,
  isHTTPS,
  offsetTop,
  getUrl,
  getHomeUrl,
  getUrlParameter,
  getParameterFromURL,
  getUrlLabelParameter,
  redirect,
  goToCart,
  goToOldCart,
  getFormatedPrice,
  isOnSpaSite,
  getTimestamp,
  getUTCTimestamp,
  formatInto12Hours,
  formatTwoDigits,
  formatImageUrl,
  isEmailValid,
  getDataLayerPush,
  isSiteLightview,
  stripHTML,
  checkTextareaLength,
  setAutomaticalHeight,
  randomString,
  replaceLast,
  isAlgoliaOn,
  isTargetChildOf,
  inViewport,
  debounce,
  removeDuplicates,
  isEmailValidNewsletter
};



// WEBPACK FOOTER //
// ./js/common/Utils.js